"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var shared_1 = require("../../../shared");

var mobx_react_1 = require("mobx-react");

exports.TranslationContext = react_1.createContext({
  translate: function translate(key, placeholders) {
    return key;
  },
  culture: 'Default'
});

var Translate_meta_1 = require("./Translate.meta");

var Translate =
/** @class */
function (_super) {
  __extends(Translate, _super);

  function Translate() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.categoryKey = Translate_meta_1.TRANSLATE_CATEGORY_KEY;
    _this.componentKey = Translate_meta_1.TRANSLATE_COMPONENT_KEY;
    return _this;
  }

  Object.defineProperty(Translate.prototype, "translation", {
    get: function get() {
      var _a = this.props,
          children = _a.children,
          placeholders = _a.placeholders;

      if (typeof children !== 'string' || !this.context || !this.context.translate) {
        return children;
      }

      return this.context.translate(children, placeholders);
    },
    enumerable: true,
    configurable: true
  });

  Translate.prototype.render = function () {
    return react_1.default.createElement(react_1.Fragment, null, this.translation);
  };

  Translate.contextType = exports.TranslationContext;
  Translate = __decorate([mobx_react_1.observer], Translate);
  return Translate;
}(shared_1.ComponentBase);

exports.Translate = Translate;
exports.default = Translate;